import React from 'react'
import { withPrefix } from 'gatsby'
import { LinkButton } from '@leshen/gatsby-theme-leshen'
import Logo from '../images/availability/logo.svg'
import DynamicPhoneCTA from './DynamicPhoneCTA'
import topBarNavData from '../data/topBarData'
import navData from '../data/headerData'

function header() {
  return {
    navData,
    topBarNavData,
    hoverTextColor: 'black',
    hoverBackgroundColor: 'primary',
    logo: <img src={Logo} alt="Logo" />,
    logoLink: withPrefix('/'),
    callToActions: (
      <>
        <LinkButton
          to="https://my.dish.com/login"
          target="_blank"
          color="primary"
          className="margin-x-auto"
        >
          Log in to MyDish
        </LinkButton>
        <DynamicPhoneCTA />
      </>
    ),
  }
}

export default header
